<template>
  <div id="conntent">
    <section class="vintalight" id="vintalight">
          <figure class="vintalight__container">
            <div class="vintalight__photo"><img class="vintalight__img" src="../assets/gallery/kiss.jpg" alt="$t('gallery.kiss')"></div>
            <figcaption class="vintalight__caption">
              <h3 class="vintalight__text"> {{ $t('gallery.kiss') }} = <span class="glyphicon glyphicon-heart"></span></h3>
            </figcaption>
          </figure>
          <figure class="vintalight__container">
            <div class="vintalight__photo"><img class="vintalight__img" src="../assets/gallery/svaneti.jpg" alt="$t('gallery.svaneti')"></div>
            <figcaption class="vintalight__caption">
              <h3 class="vintalight__text">{{ $t('gallery.svaneti') }}</h3>
            </figcaption>
          </figure>
          <figure class="vintalight__container">
            <div class="vintalight__photo"><img class="vintalight__img" src="../assets/gallery/music_fest.jpg" alt="$t('gallery.musicfest')"></div>
            <figcaption class="vintalight__caption">
              <h3 class="vintalight__text">{{ $t('gallery.musicfest') }}</h3>
            </figcaption>
          </figure>
          <figure class="vintalight__container">
            <div class="vintalight__photo"><img class="vintalight__img" src="../assets/gallery/alicante.jpg" alt="$t('gallery.alicante')"></div>
            <figcaption class="vintalight__caption">
              <h3 class="vintalight__text">{{ $t('gallery.alicante') }}</h3>
            </figcaption>
          </figure>
          <figure class="vintalight__container">
            <div class="vintalight__photo"><img class="vintalight__img" src="../assets/gallery/prague.jpg" alt="$t('gallery.prague')"></div>
            <figcaption class="vintalight__caption">
              <h3 class="vintalight__text">{{ $t('gallery.prague') }}</h3>
            </figcaption>
          </figure>
          <figure class="vintalight__container">
            <div class="vintalight__photo"><img class="vintalight__img" src="../assets/gallery/tusheti.jpg" alt="$t('gallery.tusheti')"></div>
            <figcaption class="vintalight__caption">
              <h3 class="vintalight__text">{{ $t('gallery.tusheti') }}</h3>
            </figcaption>
          </figure>
          <figure class="vintalight__container">
            <div class="vintalight__photo"><img class="vintalight__img" src="../assets/gallery/lisboa.jpg" alt="$t('gallery.lisboa')"></div>
            <figcaption class="vintalight__caption">
              <h3 class="vintalight__text">{{ $t('gallery.lisboa') }}</h3>
            </figcaption>
          </figure>
          <figure class="vintalight__container">
            <div class="vintalight__photo"><img class="vintalight__img" src="../assets/gallery/lisboa2.jpg" alt="$t('gallery.lisboa2')"></div>
            <figcaption class="vintalight__caption">
              <h3 class="vintalight__text">{{ $t('gallery.lisboa2') }}</h3>
            </figcaption>
          </figure>
          <figure class="vintalight__container">
            <div class="vintalight__photo"><img class="vintalight__img" src="../assets/gallery/etretat.jpg" alt="$t('gallery.etretat')"></div>
            <figcaption class="vintalight__caption">
              <h3 class="vintalight__text">{{ $t('gallery.etretat') }}</h3>
            </figcaption>
          </figure>
          <figure class="vintalight__container">
            <div class="vintalight__photo"><img class="vintalight__img" src="../assets/gallery/new_year.jpg" alt="$t('gallery.newyear')"></div>
            <figcaption class="vintalight__caption">
              <h3 class="vintalight__text">{{ $t('gallery.newyear') }}</h3>
            </figcaption>
          </figure>
          <figure class="vintalight__container">
            <div class="vintalight__photo"><img class="vintalight__img" src="../assets/gallery/tc_wedding.jpg" alt="$t('gallery.wedding')"></div>
            <figcaption class="vintalight__caption">
              <h3 class="vintalight__text">{{ $t('gallery.wedding') }}</h3>
            </figcaption>
          </figure>
          <figure class="vintalight__container">
            <div class="vintalight__photo"><img class="vintalight__img" src="../assets/gallery/spin.gif" alt="$t('gallery.spin')"></div>
            <figcaption class="vintalight__caption">
              <h3 class="vintalight__text">{{ $t('gallery.spin') }} </h3>
            </figcaption>
          </figure>
    </section>
  </div>
</template>

<script>

export default {
  name: 'Gallery',
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

// == Variables == //
$size: 30px; // Tamaño
$resize: 0.7; // Redimencionamiento
$fig-width: 10.5em; // Ancho contenedor fotografía
$fig-height: 12.25em; // Alto contenedor fotografía
$photo-size: 9.25em; // Tamaño fotografía
$font-size: 0.7em; // Tamaño fuente
$font-description: 'Nanum Pen Script', cursive; // Fuente fotografía

*,
*::before,
*::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

// == Función para redimensionar en pantalla pequeña == //
@function resize($size-function) {
    @return $size-function * $resize;
}

// == Mixin media == //
@mixin media($screen: 500px) {
    @media screen and (max-width: $screen){
        @content;
    }
}

// == Mixin para posicionar y rotar fotografías == //
@mixin rotate($deg, $index, $transX, $transY) {
    transform: translate($transX, $transY) rotate($deg);
    z-index: $index;
    &:hover {
        transform: scale(1.15) translate($transX, $transY) rotate(0);
    }
    @include media(700px) {
        transform: translate(0) rotate($deg);
        &:hover {
            transform: scale(1.1) translate(0) rotate(0);
        }
    }
}

.vintalight {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    // width: 90%;
    // max-width: 1200px;
    padding: 50px 0;
    &__container {
        position: relative;
        width: 90%;
        max-width: $fig-width;
        height: $fig-height;
        background-color: #fff;
        font-size: $size;
        box-shadow: 0 2px 6px 1px rgba(#000, 0.5);
        transition: transform 0.5s cubic-bezier(0.075, 0.82, 0.165, 1), box-shadow 0.5s, margin 0.5s;
        @include media {
            max-width: resize($fig-width);
            height: resize($fig-height);
        }
        &:nth-child(1) {
            @include rotate(-30deg, 40, 40px, 30px);
        }
        &:nth-child(2) {
            @include rotate(7deg, 50, 30px, 20px);
        }
        &:nth-child(3) {
            @include rotate(20deg, 40, -20px, 20px);
        }
        &:nth-child(4) {
            @include rotate(10deg, 30, 40px, -10px);
        }
        &:nth-child(5) {
            @include rotate(-20deg, 20, 30px, -20px);
        }
        &:nth-child(6) {
            @include rotate(-10deg, 40, 30px, -40px);
        }&:nth-child(7) {
            @include rotate(-30deg, 40, 40px, 30px);
        }
        &:nth-child(8) {
            @include rotate(7deg, 50, 30px, 20px);
        }
        &:nth-child(9) {
            @include rotate(20deg, 40, -20px, 20px);
        }
        &:nth-child(10) {
            @include rotate(10deg, 30, 40px, -10px);
        }
        &:nth-child(11) {
            @include rotate(-20deg, 20, 30px, -20px);
        }
        &:nth-child(12) {
            @include rotate(-10deg, 40, 30px, -40px);
        }
        &:hover {
            box-shadow: 0 4px 8px 3px rgba(#000, 0.4);
            z-index: 100;
            @include media(700px) {
                margin: 0 25px;
            }
        }
        &.active,
        &.active:hover {
            transform: rotate(0) scale(1.75);
            @include media {
                transform: rotate(0) scale(1.5);
            }
        }
        &.active {
            position: relative;
            .vintalight__photo {
                cursor: default;
            }
        }
    }
    &__photo {
        position: relative;
        width: $photo-size;
        height: $photo-size;
        margin: (($fig-width - $photo-size) / 2) auto 0;
        @include media {
            width: resize($photo-size);
            height: resize($photo-size);
            margin: ((resize($fig-width) - resize($photo-size)) / 2) auto 0;
        }
        overflow: hidden;
        cursor: pointer;
    }
    &__img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    &__caption {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: ($fig-height - $photo-size) - (($fig-width - $photo-size) / 2);
        @include media {
            height: (resize($fig-height) - resize($photo-size)) - ((resize($fig-width) - resize($photo-size)) / 2);
        }
    }
    &__text {
        color: #222;
        font-size: $font-size;
    }
    &-overlay {
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: rgba(#000, 0.5);
        opacity: 0;
        z-index: 10000;
        transition: opacity 0.5s;
        &.active {
            opacity: 1;
        }
    }
    &__button {
        position: absolute;
        $size-button: 30px;
        top: ($size-button / -2);
        right: ($size-button / -2);
        width: $size-button;
        height: $size-button;
        background-color: #0176A6;
        border: 3px solid #fff;
        border-radius: 50%;
        outline: none;
        color: #fff;
        font-size: ($size-button / 2);
        font-weight: bold;
        box-shadow: -2px 2px 1px rgba(#000, 0.3);
        z-index: 10000;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue